import { render, staticRenderFns } from "./TableViewContainer.vue?vue&type=template&id=70a8ee7c&"
import script from "./TableViewContainer.vue?vue&type=script&lang=js&"
export * from "./TableViewContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports